import { render, staticRenderFns } from "./core_waybill.vue?vue&type=template&id=9ca0521a&scoped=true&"
import script from "./core_waybill.vue?vue&type=script&lang=js&"
export * from "./core_waybill.vue?vue&type=script&lang=js&"
import style0 from "./core_waybill.vue?vue&type=style&index=0&id=9ca0521a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca0521a",
  null
  
)

export default component.exports